<template>
  <router-view></router-view>
  <div class="fix_top">
    <!-- @mouseleave="leave()" -->
    <div class="wechat" @mouseenter="enter()">
      <img src="./assets/wechatl.png" alt="" v-if="data.serverStatus" />
      <img src="./assets/wechath.png" alt="" v-else />
    </div>
    <div class="line"></div>
    <!-- @mouseleave="wechatLeave()" -->
    <div class="server" @mouseenter="wechatEnter()">
      <img src="./assets/serverl.png" alt="" v-if="data.wechatStatus" />
      <img src="./assets/serverh.png" alt="" v-else />
    </div>
  </div>
  <div class="phone flex" @mouseleave="wechatLeave()" v-if="data.wechatStatus">
    400-6696-280
  </div>
  <div
    style="
      position: fixed;
      bottom: 366px;
      right: 57px;
      z-index: 999;

      width: 141px;
      height: 172px;
    "
    v-if="data.serverStatus"
    @mouseleave="leave()"
  >
    <div class="content">
      <div class="scan">
        <img src="./assets/scan.png" alt="" />
      </div>
      <div class="scan_btn flex">微信咨询</div>
    </div>
  </div>
  <div class="fix_round flex" @click="top">
    <img src="./assets/top-icon.png" alt="" />
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted, reactive } from "vue";
import Footer from "@/components/Footer.vue";

import DevcePixelRatio from "./tools/DevicePixelRatio";
//窗口大小兼容
let bodyScale = () => {
  var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
  var scale = devicewidth / 1920; // 分母——设计稿的尺寸
  document.body.style.zoom = scale; //放大缩小相应倍数
};
const data = reactive({
  serverStatus: false,
  wechatStatus: false,
});
onMounted(() => {
  new DevcePixelRatio().init();
  bodyScale();
});
function top() {
  document.documentElement.scrollTop = 0;
}
//防抖处理
let timer = ref(null);
function fn() {
  clearTimeout(timer.value);
  timer.value = setTimeout(() => {
    bodyScale();
  }, 300);
}
function enter() {
  data.serverStatus = true;

  if (data.wechatStatus) {
    data.wechatStatus = false;

    data.serverStatus = true;
  } else {
    data.serverStatus = true;
  }
}
function wechatEnter() {
  if (data.serverStatus) {
    data.serverStatus = false;
    data.wechatStatus = true;
  } else {
    data.wechatStatus = true;
  }
}
function wechatLeave() {
  data.wechatStatus = false;
  console.log("微信");
}
function leave() {
  data.serverStatus = false;
  console.log("客服");
}
onMounted(() => {
  window.addEventListener("scroll", () => {
    data.serverStatus = false;
    data.wechatStatus = false;
  });
});
onUnmounted(() => {
  // window.removeEventListener("scroll", scrollBar)
});
window.addEventListener("resize", fn);
// //销毁清除全局引用
// onUnmounted(() => [
//   window.removeEventListener("resize", fn)
// ])
</script>

<style>
#app {
  box-sizing: border-box;
  padding-bottom: 70px;
}
</style>

<style lang="scss" scoped>
.phone {
  width: 140px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 24px;
  border: 1px solid #f1f1f1;
  position: fixed;
  bottom: 426px;
  // right: 63px;
  right: 70px;
  display: flex;
  color: #222222;
  z-index: 999;
}

.content {
  width: 140px;
  height: 172px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 21px;
  border: 1px solid #f1f1f1;
  position: fixed;
  bottom: 366px;
  // right: 63px;
  right: 70px;

  z-index: 999;
  animation: move 2s linear;

  .scan {
    width: 105px;
    height: 105px;

    margin: 16px 16px 13px 17px;

    img {
      background-size: 100%, 100%;
    }
  }

  // @keyframes move {
  //   0% {
  //     transform: translateX(200px)
  //   }

  //   // 50% {
  //   //   transform: translateX(25px)
  //   // }

  // }

  .scan_btn {
    width: 105px;
    height: 22px;
    background: #34c88a;
    border-radius: 11px;
    margin: 0px 17px 16px 18px;
    cursor: pointer;

    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
  }
}

.fix_top {
  cursor: pointer;

  .wechat {
    width: 18px;

    height: 18px;

    margin-top: 26px;
    margin-left: 12px;
    margin-right: 12px;

    img {
      width: 18px;

      height: 18px;
      background-size: 100%, 100%;
    }
  }

  .server {
    width: 18px;
    height: 18px;
    margin-top: 15px;
    margin-left: 12px;
    margin-right: 12px;

    img {
      width: 18px;
      height: 18px;
      // background: url(../assets/top-icon.png) no-repeat;
      //     background-size: 100%,100%;
    }
  }

  .line {
    width: 13px;
    height: 1px;
    background: #cccccc;
    border-radius: 1px;
    margin-left: 14px;
    margin-right: 14px;
    margin-top: 15px;
  }

  width: 42px;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 21px;
  border: 1px solid #f1f1f1;
  position: fixed;
  bottom: 420px;
  right: 11px;
  z-index: 999;
}

.fix_round {
  width: 42px;
  height: 52px;

  img {
    width: 18px;
    height: 18px;
    // background: url(../assets/top-icon.png) no-repeat;
    //     background-size: 100%,100%;
  }

  position: fixed;
  bottom: 360px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
  width: 42px;
  height: 42px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 21px;
  border: 1px solid #f1f1f1;
  right: 11px;
  z-index: 999;
}
</style>
